const PRICE=5.99;
const FL={
  sk:{name:'Strawberry Kiwi',color:'#d42b2b',field:'#8a1710',short:'SK'},
  mn:{name:'Mint',color:'#1a9e82',field:'#0a5c48',short:'MN'}
};
/* Sobrescribe nombres/colores de sabores desde los ajustes del tema (Shopify) */
if(window.RUSH_FL){for(var _fk in window.RUSH_FL){if(FL[_fk]){var _o=window.RUSH_FL[_fk];if(_o.name)FL[_fk].name=_o.name;if(_o.color)FL[_fk].color=_o.color;if(_o.field)FL[_fk].field=_o.field;}}}
const TD=[
  {t:'✓ SIN NICOTINA',hi:true},{t:'✓ SIN TABACO',hi:true},
  {t:'100mg cafeína natural',hi:false},{t:'0 calorías · 0 azúcar',hi:false},
  {t:'Absorción sublingual directa',hi:true},{t:'15 pouches / lata',hi:false},
  {t:'★★★★★ 4.8/5',hi:false},{t:'Envío 24-48h España',hi:false},
  {t:'Envío gratis +€20',hi:false},{t:'Devolución 30 días',hi:false},
  {t:'Fabricado en España',hi:false}
];
const FAQS=[
  {q:'¿Los pouches contienen nicotina?',a:'No. Cero nicotina, cero tabaco. RUSH es un pouch de cafeína natural. La energía proviene de cafeína (100mg/pouch) y vitaminas B. Sin dependencia, sin restricciones relacionadas con el tabaco.'},
  {q:'¿Es normal el hormigueo al colocarlo?',a:'Sí, es completamente normal y buena señal. El hormigueo leve indica que la absorción sublingual está activa. Desaparece en 2-3 minutos.'},
  {q:'¿Cuántos pouches puedo tomar al día?',a:'Máximo 4-5 pouches diarios (400-500mg de cafeína). Deja al menos 1-2 horas entre cada toma. No recomendado después de las 18h si eres sensible a la cafeína.'},
  {q:'¿En qué se diferencia de una bebida energética?',a:'Las bebidas energéticas tienen 27-54g de azúcar y 110-230 kcal. Tardan 20-30 min en hacer efecto. RUSH tiene 0 azúcar, 0 calorías, y la cafeína actúa en 3-5 min por absorción sublingual directa.'},
  {q:'¿Puedo usarlo durante el deporte?',a:'Sí, es ideal. Al no ser líquido no genera molestias gástricas. Úsalo 10-15 min antes de empezar para notar el efecto durante el entreno.'},
  {q:'¿Cómo funciona la suscripción?',a:'Eliges cuántas latas y con qué frecuencia. Tienes envío gratis, descuento automático y sin permanencia. Cancela o pausa en cualquier momento desde tu cuenta.'},
  {q:'¿Cuánto tarda en llegar?',a:'Pedidos antes de las 14h en días laborables, mismo día. Entrega en 24-48h a toda España. Envío gratis a partir de €20. Devolución gratuita en 30 días.'},
];
const FAQS_PDP=[
  {q:'¿Contiene nicotina?',a:'No. Cero nicotina, cero tabaco. Solo cafeína natural (100mg), vitaminas B3, B6 y B12, y Cromo Picolinato. Sin dependencia ni restricciones.'},
  {q:'¿El hormigueo es normal?',a:'Sí, es la señal de que la absorción sublingual está activa. Dura 2-3 minutos y desaparece solo.'},
  {q:'¿Cuántos puedo tomar al día?',a:'Máximo 4-5 pouches (400-500mg de cafeína total). Espera al menos 1-2h entre tomas.'},
  {q:'¿Para qué sirven las vitaminas B?',a:'B3, B6 y B12 apoyan el metabolismo energético, reducen la fatiga y ayudan al sistema nervioso. El Cromo Picolinato estabiliza la glucosa.'},
  {q:'¿Cuándo noto el efecto?',a:'En 3-5 minutos. La absorción sublingual directa evita el tiempo de digestión. El efecto dura 3-5 horas.'},
  {q:'¿La suscripción tiene compromiso?',a:'No. Sin permanencia, sin costes ocultos. Cancela o pausa cuando quieras desde tu cuenta. El descuento se aplica desde el primer envío.'},
];

let heroIdx=0, pdpFl='sk', vMode='video', subMode='sub', packQty=1, subFreq=1;
let cart=[], heroTimer=null, timerFill=null;

// ── ACCENT COLOR ──
function setAcc(fl){
  document.documentElement.style.setProperty('--acc',FL[fl].color);
  document.documentElement.style.setProperty('--field',FL[fl].field);
}

// ── INIT ──
window.addEventListener('DOMContentLoaded',()=>{
  buildTicker();
  buildFAQ('faq-home',window.RUSH_FAQS||FAQS);
  buildFAQ('faq-pdp',window.RUSH_FAQS_PDP||FAQS_PDP);
  setAcc(window.RUSH_INIT_FL||'sk');
  heroFl(0,false);
  applyPdpFl(window.RUSH_INIT_FL||'sk');
  renderPrices();
  startHeroTimer();
  window.addEventListener('scroll',onScroll);
});

function onScroll(){
  const show=window.scrollY>480;
  document.getElementById('sticky-buy').classList.toggle('show',show);
  const el=document.body;
  const h=el.scrollHeight-window.innerHeight;
  if(h>0) document.getElementById('pbar').style.width=(window.scrollY/h*100)+'%';
}

// ── ROUTING ──
function goPage(p){
  document.querySelectorAll('.page').forEach(el=>el.classList.remove('on'));
  document.getElementById('page-'+p).classList.add('on');
  window.scrollTo(0,0);
  if(p==='cart') renderCart();
  if(p==='checkout') renderCheckout();
  if(p==='product'){
    document.getElementById('page-product').style.display='block';
    setTimeout(()=>{
      try{document.getElementById('vid-sk').play();}catch(e){}
      try{document.getElementById('vid-mn').play();}catch(e){}
    },100);
  }
}
function sv(sel){
  goPage('home');
  setTimeout(()=>{const el=document.querySelector(sel);if(el)el.scrollIntoView({behavior:'smooth'});},80);
}

// ── HERO FLAVOR SWITCH ──
function heroFl(i, animate=true){
  heroIdx=i;
  const fl=i===0?'sk':'mn';
  setAcc(fl);
  // eyebrow
  const ey=document.getElementById('hero-ey');
  if(ey) ey.textContent=FL[fl].name+' · Cafeína Natural · España';
  // field
  const cf=document.getElementById('hero-field');
  if(cf) cf.style.background=FL[fl].field;
  // wm
  const wm=document.getElementById('hero-wm');
  if(wm) wm.textContent=FL[fl].short;
  // cans
  ['sk','mn'].forEach((f,j)=>{
    const c=document.getElementById('hcan-'+f);
    if(c){c.classList.toggle('on',j===i);c.classList.toggle('off',j!==i);}
  });
  // pills
  document.querySelectorAll('#hero-pills .fp').forEach(b=>b.classList.toggle('on',parseInt(b.dataset.i)===i));
  // howto cans
  const h0=document.getElementById('hw-can-0'),h1=document.getElementById('hw-can-1');
  if(h0) h0.style.opacity=i===0?'1':'0';
  if(h1) h1.style.opacity=i===1?'1':'0';
}

// ── AUTO-ROTATE every 7 seconds ──
function startHeroTimer(){
  if(heroTimer) clearInterval(heroTimer);
  resetTimerFill();
  heroTimer=setInterval(()=>{
    heroFl((heroIdx+1)%2);
    resetTimerFill();
  },7000);
}
function resetTimerFill(){
  timerFill=document.getElementById('hero-timer-fill');
  if(!timerFill) return;
  timerFill.classList.remove('run');
  void timerFill.offsetWidth; // reflow
  timerFill.classList.add('run');
}
function manualFl(i){
  heroFl(i);
  startHeroTimer(); // reset timer on manual click
}

// ── TICKER ──
function buildTicker(){
  const src=window.RUSH_TICKER||TD;
  const all=[...src,...src];
  const el=document.getElementById('ticker-track');
  if(el) el.innerHTML=all.map(d=>`<span class="ti${d.hi?' hi':''}">${d.t}</span>`).join('');
}

// ── FAQ ──
function buildFAQ(id,data){
  const el=document.getElementById(id);
  if(!el)return;
  el.innerHTML=data.map((f,i)=>`<div class="faq-item" id="${id}i${i}">
    <div class="faq-q" onclick="tFAQ('${id}',${i})"><span>${f.q}</span><span class="faq-ico">+</span></div>
    <div class="faq-body"><p class="faq-txt">${f.a}</p></div>
  </div>`).join('');
}
function tFAQ(id,i){
  const el=document.getElementById(id+'i'+i);
  const open=el.classList.contains('open');
  document.querySelectorAll('#'+id+' .faq-item').forEach(e=>{
    e.classList.remove('open');
    e.querySelector('.faq-body').style.maxHeight='0';
  });
  if(!open){
    el.classList.add('open');
    el.querySelector('.faq-body').style.maxHeight=el.querySelector('.faq-body').scrollHeight+'px';
  }
}

// ── MENU ──
function toggleMenu(){
  document.getElementById('hbg').classList.toggle('open');
  document.getElementById('mob-menu').classList.toggle('open');
}
function closeMenu(){
  document.getElementById('hbg').classList.remove('open');
  document.getElementById('mob-menu').classList.remove('open');
}
function closeAnn(){document.getElementById('ann').classList.add('hidden');}

// ── PDP ──
function applyPdpFl(fl){
  pdpFl=fl;
  setAcc(fl);
  const cf=document.getElementById('pdp-cf');
  if(cf) cf.style.background=FL[fl].field;
  const wm=document.getElementById('pdp-wm');
  if(wm) wm.textContent=FL[fl].short;
  const lbl=document.getElementById('pdp-fl-lbl');
  if(lbl) lbl.textContent=FL[fl].name+' '+(window.RUSH_FL_SUFFIX||'— 100% Natural · Sin Nicotina');
  // videos
  ['sk','mn'].forEach(f=>{
    const v=document.getElementById('vid-'+f);
    if(!v)return;
    v.classList.toggle('on',f===fl);
    if(f===fl){try{v.play();}catch(e){}}
  });
  // cans
  ['sk','mn'].forEach(f=>{
    const c=document.getElementById('pdp-can-'+f);
    if(!c)return;
    c.classList.toggle('on',f===fl);
    c.classList.toggle('off',f!==fl);
  });
  // pills
  document.querySelectorAll('#pdp-pills .fp').forEach(b=>b.classList.toggle('on',b.dataset.fl===fl));
  renderPrices();
}
function pdpSetFl(fl){applyPdpFl(fl);}

function setViewMode(v){
  vMode=v;
  document.getElementById('vt-video').classList.toggle('on',v==='video');
  document.getElementById('vt-can').classList.toggle('on',v==='can');
  const cw=document.getElementById('pdp-can-wrap');
  if(v==='video'){
    document.querySelectorAll('.pdp__vid').forEach(vid=>{if(vid.classList.contains('on'))vid.style.opacity='1';});
    if(cw){cw.style.opacity='0';cw.style.pointerEvents='none';}
  }else{
    document.querySelectorAll('.pdp__vid').forEach(vid=>vid.style.opacity='0');
    if(cw){cw.style.opacity='1';cw.style.pointerEvents='auto';}
  }
}

// ── PURCHASE ──
function selCard(m){
  subMode=m;
  document.getElementById('sub-card').classList.toggle('sel',m==='sub');
  document.getElementById('once-card').classList.toggle('sel',m==='once');
  renderPrices();
}
function setFreq(n){
  subFreq=n;
  document.querySelectorAll('.fb').forEach(b=>b.classList.toggle('on',parseInt(b.dataset.f)===n));
  renderPrices();
}
function packSize(n){
  packQty=n;
  document.querySelectorAll('.pp').forEach(b=>b.classList.toggle('on',parseInt(b.dataset.p)===n));
  document.getElementById('qty-val').textContent=n;
  renderPrices();
}
function changeQty(d){
  packQty=Math.max(1,packQty+d);
  document.getElementById('qty-val').textContent=packQty;
  document.querySelectorAll('.pp').forEach(b=>b.classList.remove('on'));
  renderPrices();
}
function disc(){return subFreq===1?.15:subFreq===2?.1:.05;}
function renderPrices(){
  const base=packQty*PRICE,d=disc(),fin=base*(1-d);
  const sn=document.getElementById('sc-new-price');if(sn)sn.textContent='€'+fin.toFixed(2);
  const so=document.getElementById('sc-old-price');if(so)so.textContent='€'+base.toFixed(2);
  const op=document.getElementById('oc-price');if(op)op.textContent='€'+base.toFixed(2);
  const al=document.getElementById('add-lbl'),ap=document.getElementById('add-price');
  if(subMode==='sub'){if(al)al.textContent='SUSCRIBIRME';if(ap)ap.textContent='€'+fin.toFixed(2)+'/mes';}
  else{if(al)al.textContent='AÑADIR AL CARRITO';if(ap)ap.textContent='€'+base.toFixed(2);}
}
function addToCart(){
  const base=packQty*PRICE;
  if(subMode==='sub'){
    const d=disc(),fin=parseFloat((base*(1-d)).toFixed(2));
    cart.push({id:Date.now(),isSub:true,fl:pdpFl,qty:packQty,total:fin,baseTotal:parseFloat(base.toFixed(2)),pct:Math.round(d*100),freq:subFreq});
  }else{
    cart.push({id:Date.now(),isSub:false,fl:pdpFl,qty:packQty,total:parseFloat(base.toFixed(2))});
  }
  updBadge();showToast('✓  Añadido al carrito');
}
function updBadge(){
  const n=cart.reduce((a,c)=>a+c.qty,0);
  const b=document.getElementById('cart-n');
  if(b){b.textContent=n;b.classList.toggle('show',n>0);}
}
function cartTots(){const s=cart.reduce((a,c)=>a+c.total,0);const sh=s>=20?0:3.99;return{sub:s,ship:sh,total:s+sh};}

function getImg(fl){
  const el=document.getElementById('pdp-can-'+fl);
  return el?el.src:'';
}
function renderCart(){
  const body=document.getElementById('cart-body');
  const lbl=document.getElementById('cart-sub-lbl');
  const tot=cart.reduce((a,c)=>a+c.qty,0);
  if(lbl) lbl.textContent=tot+' lata'+(tot!==1?'s':'');
  if(!body)return;
  if(!cart.length){
    body.innerHTML='<div class="empty-cart"><h2>Tu carrito está vacío</h2><p>Añade tus RUSH pouches.</p><button class="btn btn-w" style="margin:0 auto" onclick="goPage(\'product\')">Ver productos</button></div>';
    return;
  }
  body.innerHTML=cart.map(item=>`
    <div class="ci">
      <div class="ci-img"><img src="${getImg(item.fl)}" alt=""></div>
      <div>
        <div class="ci-n">RUSH ${FL[item.fl].name}${item.isSub?' · <span style="color:var(--y)">Sub</span>':''}</div>
        <div class="ci-m">${item.qty}× lata${item.qty!==1?'s':''}${item.isSub?` · cada ${item.freq} mes${item.freq!==1?'es':''}`:''}</div>
        ${item.isSub?`<div style="font-size:.54rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:.1rem .4rem;background:rgba(245,200,0,.1);color:var(--y);border:1px solid rgba(245,200,0,.28);display:inline-block;margin-top:.25rem">−${item.pct}%</div>`:''}
        <button class="ci-rm" onclick="rmItem(${item.id})">Eliminar</button>
      </div>
      <div class="ci-p">€${item.total.toFixed(2)}${item.isSub?`<span class="ci-ps">antes €${item.baseTotal.toFixed(2)}</span>`:''}</div>
    </div>`).join('');
  const t=cartTots();
  body.innerHTML+=`
    <div class="cart-sum">
      <div class="cs-r"><span>Subtotal</span><span>€${t.sub.toFixed(2)}</span></div>
      <div class="cs-r"><span>Envío</span><span>${t.ship===0?'<span style="color:var(--y)">Gratis</span>':'€'+t.ship.toFixed(2)}</span></div>
      ${t.ship>0?'<div style="font-size:.64rem;color:rgba(255,255,255,.34);margin:-.38rem 0 .42rem">Gratis a partir de €20</div>':''}
      <div class="cs-r tot"><span>Total</span><span class="cs-v">€${t.total.toFixed(2)}</span></div>
    </div>
    <button class="btn btn-w" style="width:100%;margin-bottom:.8rem;font-size:.8rem" onclick="goPage('checkout')">Continuar con el pago</button>
    <div style="display:flex;align-items:center;gap:.65rem;padding:.8rem 1rem;border:1px solid rgba(255,255,255,.2);background:rgba(255,255,255,.025);margin-bottom:.8rem">
      <span style="font-size:1.2rem;color:var(--y)">🛡</span>
      <span style="font-size:.72rem;font-weight:700;color:rgba(255,255,255,.85)">30 días de devolución gratuita · Sin preguntas</span>
    </div>
    <div class="pay-chips"><span class="pay-chip">VISA</span><span class="pay-chip">Mastercard</span><span class="pay-chip">Bizum</span><span class="pay-chip">PayPal</span><span style="font-size:.62rem;color:rgba(255,255,255,.35)">🔒 SSL</span></div>`;
  document.getElementById('co-total-btn').textContent='€'+t.total.toFixed(2);
}
function rmItem(id){cart=cart.filter(c=>c.id!==id);updBadge();renderCart();}

function renderCheckout(){
  document.getElementById('success-pg').style.display='none';
  document.getElementById('checkout-form').style.display='';
  const items=document.getElementById('co-items');
  if(items) items.innerHTML=cart.map(item=>`
    <div class="co-item">
      <div class="co-item-img"><img src="${getImg(item.fl)}" alt=""></div>
      <div><div class="co-item-n">RUSH ${FL[item.fl].name}${item.isSub?' · Sub':''}</div><div class="co-item-m">${item.qty} lata${item.qty!==1?'s':''}</div></div>
      <div class="co-item-p">€${item.total.toFixed(2)}</div>
    </div>`).join('');
  const t=cartTots();
  const tots=document.getElementById('co-tots');
  if(tots) tots.innerHTML=`
    <div class="co-tr"><span>Subtotal</span><span>€${t.sub.toFixed(2)}</span></div>
    <div class="co-tr"><span>Envío</span><span>${t.ship===0?'Gratis':'€'+t.ship.toFixed(2)}</span></div>
    <div class="co-tr fin"><span>Total</span><span class="co-v">€${t.total.toFixed(2)}</span></div>`;
  document.getElementById('co-total-btn').textContent='€'+t.total.toFixed(2);
}
function placeOrder(){
  const ref='RUSH-'+Math.random().toString(36).substr(2,6).toUpperCase();
  document.getElementById('order-ref').textContent=ref;
  document.getElementById('checkout-form').style.display='none';
  document.getElementById('success-pg').style.display='';
  cart=[];updBadge();
}

function showToast(msg){
  const t=document.getElementById('toast');
  if(!t)return;
  t.textContent=msg;t.classList.add('on');
  setTimeout(()=>t.classList.remove('on'),2400);
}
function fmtCard(el){let v=el.value.replace(/[^0-9]/g,'').slice(0,16);el.value=v.replace(/(.{4})/g,'$1 ').trim();}
function fmtExp(el){let v=el.value.replace(/[^0-9]/g,'').slice(0,4);if(v.length>=3)v=v.slice(0,2)+' / '+v.slice(2);el.value=v;}

let mixSK=1, mixMN=0;

function packSize(n){
  packQty=n;
  document.querySelectorAll('.pp').forEach(b=>b.classList.toggle('on',parseInt(b.dataset.p)===n));
  document.getElementById('qty-val').textContent=n;
  mixSK=(pdpFl==='sk')?n:0;
  mixMN=(pdpFl==='mn')?n:0;
  updateMixUI();
  buildPackStages();
  renderPrices();
}

function changeMix(fl,d){
  const total=packQty;
  if(fl==='sk'){mixSK=Math.max(0,Math.min(total,mixSK+d));mixMN=total-mixSK;}
  else{mixMN=Math.max(0,Math.min(total,mixMN+d));mixSK=total-mixMN;}
  updateMixUI();
  buildPackStages();
  renderPrices();
}

function updateMixUI(){
  const sk=document.getElementById('mix-n-sk'),mn=document.getElementById('mix-n-mn');
  const tv=document.getElementById('mix-total-val');
  const wrap=document.getElementById('mix-selector');
  if(sk) sk.textContent=mixSK;
  if(mn) mn.textContent=mixMN;
  if(tv) tv.textContent=mixSK+' SK + '+mixMN+' MN = '+packQty+' latas ✓';
  if(wrap) wrap.style.display=packQty>1?'block':'none';
}

function buildPackStages(){
  if(vMode==='video') return;
  const stage=document.getElementById('pdp-stage');
  if(!stage) return;
  const skSrc=document.getElementById('pdp-can-sk').src;
  const mnSrc=document.getElementById('pdp-can-mn').src;
  stage.innerHTML='';
  stage.classList.add('show');
  const positions={
    1:[[0,0,82,0,2]],
    3:[[-18,-8,78,-12,1],[0,0,88,0,2],[18,-8,78,12,1]],
    6:[[-28,-10,72,-14,0.45],[-15,-6,80,-8,0.65],[0,0,88,0,1],[15,-6,80,8,0.65],[28,-10,72,14,0.45]]
  };
  const layouts=positions[packQty]||positions[1];
  layouts.forEach(([tx,ty,h,rot,op])=>{
    const n=layouts.indexOf([tx,ty,h,rot,op]);
    let src;
    if(packQty===1) src=(pdpFl==='sk'?skSrc:mnSrc);
    else if(mixSK===packQty) src=skSrc;
    else if(mixMN===packQty) src=mnSrc;
    else src=n<Math.ceil(layouts.length/2)?skSrc:mnSrc;
    const img=document.createElement('img');
    img.src=src;
    img.style.cssText='height:'+h+'%;top:50%;left:50%;transform:translate(-50%,-50%) translateX('+tx+'%) translateY('+ty+'%) rotate('+rot+'deg);opacity:'+op;
    stage.appendChild(img);
  });
}

function packCustom(){
  document.querySelectorAll('.pp').forEach(b=>b.classList.remove('on'));
  document.getElementById('pp-custom').classList.add('on');
  const wrap=document.getElementById('custom-qty-wrap');
  if(wrap) wrap.style.display='block';
  const inp=document.getElementById('custom-qty-input');
  if(inp){inp.value=packQty||1;packQty=parseInt(inp.value)||1;}
  document.getElementById('qty-val').textContent=packQty;
  updateMixUI();buildPackStages();renderPrices();
}
function setCustomQty(v){
  const n=Math.max(1,Math.min(99,parseInt(v)||1));
  packQty=n;
  const inp=document.getElementById('custom-qty-input');if(inp)inp.value=n;
  document.getElementById('qty-val').textContent=n;
  mixSK=n;mixMN=0;
  updateMixUI();buildPackStages();renderPrices();
}
// Override changeQty to sync custom input
const _origChangeQty=changeQty||function(){};
changeQty=function(d){
  const n=Math.max(1,packQty+d);
  setCustomQty(n);
};
// Override packSize to hide custom wrap
const _origPackSize=packSize;
packSize=function(n){
  const wrap=document.getElementById('custom-qty-wrap');if(wrap)wrap.style.display='none';
  _origPackSize(n);
};

const _origApplyPdpFl=applyPdpFl;
applyPdpFl=function(fl){
  _origApplyPdpFl(fl);
  mixSK=(fl==='sk')?packQty:0;
  mixMN=(fl==='mn')?packQty:0;
  updateMixUI();
  buildPackStages();
};

function setViewMode(v){
  vMode=v;
  document.getElementById('vt-video').classList.toggle('on',v==='video');
  document.getElementById('vt-can').classList.toggle('on',v==='can');
  const cw=document.getElementById('pdp-can-wrap');
  const stage=document.getElementById('pdp-stage');
  if(v==='video'){
    document.querySelectorAll('.pdp__vid').forEach(vid=>{if(vid.classList.contains('on'))vid.style.opacity='1';});
    if(cw){cw.style.opacity='0';cw.style.pointerEvents='none';}
    if(stage) stage.classList.remove('show');
  } else {
    document.querySelectorAll('.pdp__vid').forEach(vid=>vid.style.opacity='0');
    if(cw){cw.style.opacity='0';cw.style.pointerEvents='none';}
    buildPackStages();
  }
}

function renderPrices(){
  const base=packQty*5.99,d=disc(),fin=base*(1-d);
  const sn=document.getElementById('sc-new-price');if(sn)sn.textContent='€'+fin.toFixed(2);
  const so=document.getElementById('sc-old-price');if(so)so.textContent='€'+base.toFixed(2);
  const op=document.getElementById('oc-price');if(op)op.textContent='€'+base.toFixed(2);
  const cup=document.getElementById('custom-unit-price');if(cup)cup.textContent='€'+(5.99).toFixed(2)+'/ud';
  const al=document.getElementById('add-lbl'),ap=document.getElementById('add-price');
  const isSub=(typeof subMode==='undefined'||subMode==='sub');
  let lbl=isSub?'SUSCRIBIRME':'AÑADIR AL CARRITO';
  let price=isSub?('€'+fin.toFixed(2)+'/mes'):('€'+base.toFixed(2));
  if(packQty>1 && mixSK>0 && mixMN>0) lbl=lbl+' ('+mixSK+' SK+'+mixMN+' MN)';
  if(al) al.textContent=lbl;
  if(ap) ap.textContent=price;
}

document.addEventListener('DOMContentLoaded',()=>{updateMixUI();});


/* SHOPIFY BRIDGE: conecta la SPA con Shopify real */
(function(){
  if (typeof goPage !== 'function') return;
  var _orig = goPage;
  window.goPage = function(p){
    if (p === 'product')  { window.location.href = (window.RUSH_PRODUCT_URL || '/collections/all'); return; }
    if (p === 'cart')     { window.location.href = '/cart'; return; }
    if (p === 'checkout') { window.location.href = '/cart'; return; }
    try { return _orig(p); } catch(e) { window.location.href = '/'; }
  };
})();
